export default __webpack_public_path__ + "static/media/delete.29b7425b.svg";